import React, { Component, Fragment } from "react";
import moment from 'moment';
import SashiDo from 'lib/SashiDo';
import Tooltip from 'rc-tooltip';
import Icon from 'components/Icon/Icon.react';
import Autocomplete from 'components/Autocomplete/Autocomplete.react';
import WorldMapBarChart from 'components/Charts/WorldMapBarChart.react';
import Pulse from './Pulse.react';
import { numeral } from 'lib/helpers';
import {
  ComposableMap,
  ZoomableGroup,
  Geographies,
  Geography,
  Markers,
  Marker,
} from "react-simple-maps"
import { Motion, spring } from "react-motion";

import LoaderDots from 'components/LoaderDots/LoaderDots.react';
import { Directions } from 'lib/Constants';
import ChromeDateRange from 'components/ChromeDateRange/ChromeDateRange.react';

import styles from 'components/Charts/Charts.scss';

export default class WorldMap extends Component {
  constructor(props) {
    super(props);

    this.state = {
      center: [0,20],
      zoom: 1,
      currentPin: {},
    }

    this.loader = null;

    this.handleZoomIn = this.handleZoomIn.bind(this);
    this.handleZoomOut = this.handleZoomOut.bind(this);
    this.handleCityClick = this.handleCityClick.bind(this);
    this.mouseEnter = this.mouseEnter.bind(this);
    this.mouseLeave = this.mouseLeave.bind(this);
    this.filter = this.filter.bind(this);
    this.onSelectItem = this.onSelectItem.bind(this);
  }

  filter(reload=true) {
    const { dateRange } = this.state;

    if(reload) {
      this.loader.classList.add('metricsLoaderShow');
    }

    setTimeout(() => {
      const { data } = this.props;
      let originalData = [ ...data ];
      const sd = dateRange.start.getTime();
      const ed = dateRange.end.getTime();

      originalData =
        originalData
          .filter((d) => {
            return Object.keys(d).length > 0
          })
          .filter((d) => {
            const time = new Date(d.timestamp).getTime();
            return (sd <= time && time <= ed);
          })

      const results = [];

      originalData.map((item) => {
          return item.value
        }).forEach((r) => {
          r.forEach((rItem) => {
            results.push({
              country: rItem.country,
              name: rItem.name,
              count: rItem.count,
              longitude: rItem.longitude,
              latitude: rItem.latitude,
            })
          });
        });

      const finalData = results.reduce((map => (r, a) => {
        map.set(a.name, map.get(a.name) || r[r.push({ country: a.country, name: a.name, count: 0, coordinates: [a.longitude, a.latitude] }) - 1]);
        map.get(a.name).count += a.count;
        return r;
      })(new Map), []);

      const byDayData =
        originalData
          .reduce((r, a) => {
            const date = moment(a.timestamp).format('YYYY-MM-DD');
            r[date] = r[date] || 0;

            a.value.forEach((c) => {
              if(c.country === this.state.currentPin.country) {
                r[date] = c.count;
              }
            });

            return r;
          }, {});

      const byDayMetrics = {
        labels: Object.keys(byDayData),
        datasets: [
          {
            name: 'Delivered files',
            values: Object.values(byDayData),
          }
        ]
      }

      setTimeout(() => {
        this.loader.classList.remove('metricsLoaderShow');

        this.setState({
          byDayMetrics,
          data: finalData,
        });
      }, 200);
    }, 100);

  }

  componentDidMount() {
    this.setState({
      dateRange: {
        start: new Date(moment().subtract(3, 'months').subtract(1, 'days')),
        end: new Date(),
      }
    }, () => {
      this.filter();
      setTimeout(() => {
        this.loader.classList.remove('metricsLoaderShow');
      }, 1000);
    });

  }

  handleZoomIn() {
    delete this.state.byDayMetrics;
    this.state.zoom = 2.4;
    this.setState(this.state);
  }

  handleZoomOut() {
    this.setState({
      center: [0,20],
      zoom: 1,
      currentPin: {},
      currentIndex: null,
    })
  }

  handleCityClick(item, i) {
    this.setState({
      zoom: 2.4,
      center: item.coordinates,
      currentPin: item,
      currentIndex: i,
    }, () => {
      this.mouseLeave();
      this.filter(false);
    });

  }


  mouseEnter(e, country) {
    const el = e.target.getBoundingClientRect();
    const top = el.top;
    const left = el.left;
    const halfWidth = el.width.toFixed() / 2;
    const halfHeight = el.height.toFixed() / 2;

    this.tooltip.style.top = (top + halfHeight).toFixed() + 'px';
    this.tooltip.style.left = (left + halfWidth).toFixed() + 'px';
    this.tooltipText.innerHTML = `${country.name} ${numeral(country.count, '0,[0]')}`;
    this.tooltip.style.opacity = 1;
  }

  mouseLeave(e) {
    this.tooltip.style.top = 0;
    this.tooltip.style.left = 0
    this.tooltip.style.opacity = 0;
  }

  onSelectItem(item) {
    const { data } = this.state;

    let index = 0;

    const selected = data.filter((country, i) => {
      const _next = country.name === item;

      if(_next) {
        index = i;
      }

      return _next;
    });

    this.handleCityClick(selected[0], index);

    return true;
  }

  render() {
    const { props, state } = this;
    const { data, zoom, byDayMetrics, currentPin, dateRange } = state;

    let autocomplateData

    if(data) {
      autocomplateData = data.map((country, i) => {
        return country.name
      });
    }

    return (
      <section className={[styles.graph, styles.map].join(' ')} style={{ minWidth: 1040 }}>
        <div className={styles.wrapper}>
          <div className={styles.graphHolder}>

            <div className={styles.tooltip} ref={t => this.tooltip = t}>
              <div ref={t => this.tooltipText = t} />
              <span></span>
            </div>
            {
              zoom === 1
                ? <div className={styles.zoom} onClick={this.handleZoomIn}>
                    <Icon name='icon-zoom-in' width={10} height={10} />
                  </div>

                :
                  <div className={styles.zoom} onClick={this.handleZoomOut}>
                    <Icon name='icon-zoom-out' width={10} height={10} />
                  </div>
            }


            <div style={{ width: this.width }} className={[styles.g, this.needScroll ? styles.needScroll : null ].join(' ')}>
              <div ref={parent => (this.parent = parent)} className={['charts', this.props.onSelect ? 'is_navigable' : null].join(' ')}>
                {
                  this.props.title &&
                    <div className={'h'}>
                      <h2 className={'title'}>
                        {this.props.title}
                        {
                          this.props.tooltip &&
                            <Tooltip placement="right" overlay={this.props.tooltip} overlayClassName={styles.rcTooltip} arrowContent={<div className="rc-tooltip-arrow-inner"></div>}>
                              <span><Icon name='icon-info' width={14} height={14} colored={true} /></span>
                            </Tooltip>
                        }
                      </h2>
                      {
                        this.props.desc &&
                          <h3 className={'desc'}>{this.props.desc}</h3>
                      }
                    </div>
                }

                {
                  autocomplateData && autocomplateData.length
                    ? (
                      <div className={styles.mapTotalCountries}>
                        Total Countries: {autocomplateData.length}
                      </div>
                    )

                    : null
                }

                {
                  zoom > 1 && byDayMetrics &&
                    <WorldMapBarChart
                      {...props}
                      focused={zoom > 1}
                      data={byDayMetrics}
                      title={`${currentPin.name} - total delivered files ${moment(dateRange.start).format('MMM DD YYYY')} to ${moment(dateRange.end).format('MMM DD YYYY')}`}
                      unit='Requests'
                      dataFormat='0,[0] a'
                      colors={['#98d85b']}
                      type={'bar'}
                      height={200}
                      />
                }
                {
                  data && data.map((country, i) => {
                    if(this.state.currentIndex === i) {
                      return <Pulse key={i} />
                    }

                    return null
                  })
                }
                <div className={styles.map}>
                  {
                    data &&
                      <Motion
                        defaultStyle={{
                          zoom: 1,
                          x: 0,
                          y: 20,
                        }}
                        style={{
                          zoom: spring(this.state.zoom, { stiffness: 210, damping: 20 }),
                          x: spring(this.state.center[0], { stiffness: 210, damping: 20 }),
                          y: spring(this.state.center[1], { stiffness: 210, damping: 20 }),
                        }}
                      >
                        {({zoom, x, y}) => (
                          <ComposableMap
                            projectionConfig={{ scale: 205 }}
                            width={980}
                            height={551}
                            style={{
                              width: "100%",
                              height: "auto",
                            }}
                          >
                            <ZoomableGroup center={[x,y]} zoom={zoom} onMoveStart={() => {}} onMoveEnd={() => {}} disablePanning>
                              <Geographies geography={require('./static/world-110m.json')} disableOptimization>
                                {
                                  (geographies, projection) => {
                                    return (
                                      geographies
                                        .filter((geography) => geography.id !== "010")
                                        .map((geography, i) => {
                                          const defaultStroke = '#607D8B';
                                          const hoverStroke = '#607D8B';
                                          let defaultFill = 'ECEFF1';
                                          let hoverFill = 'ECEFF1';

                                          if(zoom > 1) {
                                            if(geography.properties['Alpha-2'] === this.state.currentPin.country) {
                                              defaultFill = '#d4d7d9';
                                              hoverFill = '#d4d7d9';
                                            }
                                          }


                                          return (
                                            <Geography
                                              key={i}
                                              geography={geography}
                                              projection={projection}
                                              style={{
                                                default: {
                                                  fill: defaultFill,
                                                  stroke: defaultStroke,
                                                  strokeWidth: 0.3,
                                                  outline: "none",
                                                },
                                                hover: {
                                                  fill: hoverFill,
                                                  stroke: hoverStroke,
                                                  strokeWidth: 0.3,
                                                  outline: "none",
                                                },
                                                pressed: {
                                                  fill: hoverFill,
                                                  stroke: hoverStroke,
                                                  strokeWidth: 0.3,
                                                  outline: "none",
                                                },
                                              }}
                                            />
                                          );
                                        })
                                    );
                                  }
                                }
                              </Geographies>
                              <Markers>
                                {
                                  data.map((country, i) => {
                                    let color = '#ffa00a';

                                    if(zoom > 1 && this.state.currentIndex !== i) {
                                      color = 'rgba(255,160,10, .4)';
                                    }

                                    return (
                                      <Marker
                                        key={i}
                                        marker={country}
                                        >
                                        <circle
                                          className={styles.pin}
                                          onMouseEnter={(e) => this.mouseEnter(e, country)}
                                          onMouseLeave={(e) => this.mouseLeave()}
                                          onClick={(e) => {
                                            if(zoom > 1 && this.state.currentIndex === i) {
                                              this.handleZoomOut()
                                            } else {
                                              this.handleCityClick(country, i)
                                            }
                                          }}
                                          cx={0}
                                          cy={0}
                                          r={(zoom > 1 && this.state.currentIndex === i) ? 8 : 4}
                                          fill={color}
                                        />
                                      </Marker>
                                    );
                                  })
                                }
                              </Markers>
                            </ZoomableGroup>
                          </ComposableMap>
                        )}
                      </Motion>
                  }
                </div>
              </div>
            </div>
            {
                <div className={styles.segment}>
                  {
                    autocomplateData &&
                      <Autocomplete
                        width={160}
                        defValue={currentPin ? currentPin.name : ''}
                        placeholder='Choose Country ...'
                        items={autocomplateData}
                        onChoose={this.onSelectItem}
                      />
                  }

                  <div style={{ width: 30 }} />

                  <ChromeDateRange
                    value={this.state.dateRange}
                    range={[3, 'months', new Date()]}
                    onChange={(dateRange) => {
                      this.setState({ dateRange }, () => {
                        this.filter()
                      });
                    }}
                    align={Directions.BOTTOM_RIGHT}
                  />
                </div>
            }
          </div>
        </div>
        <div className={[styles.loader, 'metricsLoaderShow'].join(' ')} ref={r => (this.loader = r)}>
          <LoaderDots />
        </div>
      </section>

    )
  }
}
